import { OnSchedTemplates } from "../../OnSchedTemplates"


export const OnChangeProvince = (element, option, provinces) => {
  var elProvinceBtn = document.getElementById('onsched-province-button');
  var elProvinceInput = document.getElementById('onsched-province-hidden-input');
  let elProvinceSelected = document.querySelector(`[data-code="${option.dataset.code}"]`);
  let provinceSelectedData = {...elProvinceSelected.dataset};
  
  Object.keys(provinceSelectedData).map((provData, idx) => elProvinceBtn.dataset[provData] = Object.values(provinceSelectedData)[idx]);
  Object.keys(provinceSelectedData).map((provData, idx) => elProvinceInput.dataset[provData] = Object.values(provinceSelectedData)[idx]);

  elProvinceBtn.innerText = provinceSelectedData.name;
  elProvinceInput.value = provinceSelectedData.code;

  document.getElementById('onsched-province').classList.remove('active');
}
